import { Sheets } from './Sheets';
import { SheetsStackProps } from './Sheets.types';

export const SheetsStack = ({
  sheets,
  microcopy,
  className = '',
}: SheetsStackProps) => {
  return (
    <div className={className}>
      {sheets.map((sheet, index) => (
        <Sheets
          {...sheet}
          microcopy={microcopy}
          key={index}
          isFirstItem={index === 0}
        >
          {sheet.children}
        </Sheets>
      ))}
    </div>
  );
};
